
import { TranslationSet } from '../types';

export const profile: TranslationSet = {
  'baby.profile': {
    en: 'Baby Profile',
    ja: '赤ちゃんのプロフィール',
    es: 'Perfil del bebé',
    zh: '宝宝档案',
    fa: 'پروفایل کودک'
  },
  'baby.name': {
    en: 'Baby Name',
    ja: '赤ちゃんの名前',
    es: 'Nombre del bebé',
    zh: '宝宝名字',
    fa: 'نام کودک'
  },
  'baby.birthday': {
    en: 'Birthday',
    ja: '誕生日',
    es: 'Fecha de nacimiento',
    zh: '生日',
    fa: 'تاریخ تولد'
  },
  'baby.originalHeight': {
    en: 'Original Height',
    ja: '出生時の身長',
    es: 'Altura original',
    zh: '出生时身高',
    fa: 'قد اولیه'
  },
  'baby.originalWeight': {
    en: 'Original Weight',
    ja: '出生時の体重',
    es: 'Peso original',
    zh: '出生时体重',
    fa: 'وزن اولیه'
  },
  'baby.gender': {
    en: 'Gender',
    ja: '性別',
    es: 'Género',
    zh: '性别',
    fa: 'جنسیت'
  },
  'baby.gender.male': {
    en: 'Male',
    ja: '男の子',
    es: 'Masculino',
    zh: '男孩',
    fa: 'پسر'
  },
  'baby.gender.female': {
    en: 'Female',
    ja: '女の子',
    es: 'Femenino',
    zh: '女孩',
    fa: 'دختر'
  },
  'baby.gender.other': {
    en: 'Other',
    ja: 'その他',
    es: 'Otro',
    zh: '其他',
    fa: 'سایر'
  },
  'family.information': {
    en: 'Family Information',
    ja: '家族情報',
    es: 'Información familiar',
    zh: '家庭信息',
    fa: 'اطلاعات خانواده'
  },
  'family.parents': {
    en: 'Parents',
    ja: '両親',
    es: 'Padres',
    zh: '父母',
    fa: 'والدین'
  },
  'family.siblings': {
    en: 'Siblings',
    ja: '兄弟姉妹',
    es: 'Hermanos y hermanas',
    zh: '兄弟姐妹',
    fa: 'خواهر و برادر'
  },
  'family.grandparents': {
    en: 'Grandparents',
    ja: '祖父母',
    es: 'Abuelos',
    zh: '祖父母',
    fa: 'پدربزرگ و مادربزرگ'
  },
  'family.maternal': {
    en: 'Maternal',
    ja: '母方',
    es: 'Materno',
    zh: '外祖父母',
    fa: 'مادری'
  },
  'family.paternal': {
    en: 'Paternal',
    ja: '父方',
    es: 'Paterno',
    zh: '祖父母',
    fa: 'پدری'
  },
  'family.grandparentRelation': {
    en: 'Relation',
    ja: '関係',
    es: 'Relación',
    zh: '关系',
    fa: 'نسبت'
  }
};
